import { faCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FalconCardHeader from 'components/common/FalconCardHeader';
import Flex from 'components/common/Flex';
import { FilterContext } from 'context/Context';
import useApi from 'helpers/api';
import { colorsSecondary } from 'helpers/utils';
import React, { useContext, useEffect, useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import TicketsByCustomerChart from './TicketsByCustomerChart';

const TicketsByCustomer = ({ data, filtersDash }) => {
  const { setFilters } = useContext(FilterContext);
  const navigate = useNavigate();
  const api = useApi();
  const [customers, setCustomers] = useState([]);

  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const response = await api.customers.list('size=1000');
        if (response.content) {
          setCustomers(response.content);
        }
      } catch (error) {
        console.error(error);
      }
    };
    fetchCustomers();
  }, []);

  const processFilterArray = (value) => {
    if (Array.isArray(value) && value.length > 0) {
      return value.map(v => {
        const parsed = parseInt(v, 10);
        return isNaN(parsed) ? v : parsed;
      });
    }
    return value || '';
  };

  const handleClick = params => {
    const { name } = params;
    const found = customers.find(
      c =>
        (c.fantasyName &&
          c.fantasyName.trim().toLowerCase() === name.trim().toLowerCase()) ||
        (c.name && c.name.trim().toLowerCase() === name.trim().toLowerCase())
    );

    if (found) {
      setFilters({
        page: 0,
        size: 20,
        code: '',
        priorities: filtersDash.priority || '',
        status: ['TO_DO', 'IN_PROGRESS', 'PENDING'],
        customer: [found.id],
        serviceCatalog: '',
        category: '',
        subcategory: '',
        subject: '',
        agent: processFilterArray(filtersDash.agent),
        serviceGroup: processFilterArray(filtersDash.serviceGroup),
        typeTicket: '',
        initialCreationDate: filtersDash.initialCreationDate || '',
        endCreationDate: filtersDash.endCreationDate || '',
        initialSolutionDate: '',
        endSolutionDate: '',
        statusSlaResponse: '',
        statusSlaSolution: '',
        createdBy: '',
        defaultFilter: ''
      });
      navigate('/tickets');
    }
  };

  return (
    <Card className="h-100">
      <FalconCardHeader
        title="Tickets em Aberto por Cliente"
        titleTag="h4"
        className="py-2"
      />
      <Card.Body className="p-3 d-flex align-items-center">
        <Row className="w-100 g-2">
          <Col lg={10} xs={12}>
            <TicketsByCustomerChart data={data} onClick={handleClick} />
          </Col>

          <Col lg={2} xs={12} className="h-100 scroll-area">
            <div style={{ height: '300px', overflowY: 'scroll' }}>
              <h6 className="mb-3">Resumo</h6>
              <div>
                {data &&
                  data.map((item, i) => (
                    <div key={item.name}>
                      <Flex>
                        <FontAwesomeIcon
                          icon={faCircle}
                          color={colorsSecondary[i]}
                          size="sm"
                        />
                        <h6
                          className="m-0 p-0 ms-1 text-nowrap overflow-hidden"
                          style={{ textOverflow: 'ellipsis' }}
                        >
                          {item.name}
                        </h6>
                      </Flex>
                      <p className="fs-10">Tickets {item.value}</p>
                    </div>
                  ))}
              </div>
            </div>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default TicketsByCustomer;
